export const endPoints = {
  GET_STATS: '/v1/lead/stat'
};
